/**
 * Levina Drapakoszyk™ — E-BOOK GRATIS JAKO OSOBNA POZYCJA KOSZYKA (0,00 zł)
 * =========================================================================
 *
 * CO ROBI
 *   E-book „Sekretny Język Kota” jest w Shopify produktem za 0,00 zł (handle `ebook-sekretny-jezyk-kota`,
 *   1 wariant, SKU LVK-EBOOK, produkt niefizyczny). Ten skrypt pilnuje, żeby w koszyku zawsze było:
 *     - 0 sztuk e-booka, gdy w koszyku NIE MA żadnej sztuki Drapakoszyka (`levina-drapakoszyk`, dowolny wariant),
 *     - dokładnie 1 sztuka e-booka, gdy jest przynajmniej jedna sztuka Drapakoszyka (nawet przy 3 koszykach).
 *   Klientka nie ma na pozycji e-booka kontrolek ilości ani „usuń” (ukrywa je szablon Liquid, patrz niżej), a i tak
 *   każda zmiana ilości jest cofana do 1. Rabaty ilościowe dotyczą tylko produktu Drapakoszyk — ustaw je w Shopify
 *   na „konkretny produkt”, wtedy e-book nie liczy się do progu (00_DECYZJE.md / 12_SHOPIFY_SETUP.md).
 *
 * JAK DZIAŁA (rekonsyliacja stanu, nie „reagowanie na przyciski”)
 *   1. Po KAŻDEJ zmianie koszyka skrypt czeka ~150 ms (debounce, żeby złożyć serię kliknięć w jedną kontrolę),
 *      pobiera `GET /cart.js`, liczy sztuki produktu Drapakoszyk (item.handle) i porównuje z e-bookiem.
 *   2. Jeśli stan jest zły: dodaje e-book (`POST /cart/add.js`), zmienia ilość do 1 albo usuwa nadmiarowe / niepotrzebne
 *      pozycje (`POST /cart/change.js`, po kluczu pozycji). Jeśli stan jest dobry — nie robi NIC (zero dodatkowych żądań
 *      poza jednym GET).
 *   3. Zapytania zmieniające koszyk proszą Shopify o wyrenderowanie sekcji (drawer, bąbelek, sekcje strony /cart),
 *      więc UI odświeża się z jednej odpowiedzi: `cart-drawer.renderContents(data, true)` (natywna ścieżka Shrine,
 *      bez ponownego otwierania), a na stronie /cart podmiana `.js-contents` w #main-cart-items i #main-cart-footer.
 *      Po 0,7 s jest jeszcze jedna kontrola „czy DOM zgadza się ze stanem”; jeśli motyw wyrenderował starą odpowiedź
 *      po nas, UI jest odświeżane z serwera (`POST /cart/update.js` z pustymi updates + sections).
 *   4. Kolejka jest SERIALIZOWANA: jedna rekonsyliacja naraz; zmiana w trakcie = jedna kolejna po zakończeniu.
 *      Własne żądania skryptu idą oryginalnym `fetch` (z pominięciem hooka), więc nie odpalają pętli.
 *   5. Wyścig dwóch kart przeglądarki (obie dodają e-book naraz → Shopify scala w jedną pozycję ×2): odpowiedź add.js
 *      pokazuje sumaryczną ilość, więc skrypt od razu odpala jeszcze jedną rekonsyliację, która cofa ilość do 1.
 *
 * WYZWALACZE (wszystkie schodzą do jednego debounce)
 *   - `window.fetch` owinięty: każde zakończone żądanie do /cart/add, /cart/change, /cart/update, /cart/clear
 *     (także z prefiksem języka i z .js / .json). Obejmuje: picker na PDP (add.js), natywny ProductForm Shrine (/cart/add),
 *     quick-add, upselle, quantity selector i „usuń” w drawerze i na /cart (change.js), czyszczenie koszyka (clear).
 *   - `XMLHttpRequest` (prototyp natywnego XHR): to samo dla aplikacji/skryptów, które nie używają fetch.
 *   - Zdarzenie koszyka Shrine `PUB_SUB_EVENTS.cartUpdate` (subscribe), jeśli istnieje. Zdarzeń z własnego źródła nie ma
 *     (skrypt niczego nie publikuje: `cart-drawer-items` reaguje na cartUpdate podmianą własnego HTML-a, więc publikowanie
 *     mogłoby zepsuć drawer).
 *   - DOMContentLoaded (stan wyjściowy — sprząta koszyk sprzed wizyty) i `pageshow` z bfcache.
 *
 * WARIANT E-BOOKA
 *   Pobierany z `/products/<handle>.js` (AJAX Product API): pierwszy dostępny wariant. Wynik w sessionStorage
 *   (klucz `lvkEbookVariant`, 6 h; „brak/niedostępny” tylko 5 min). Gdy dodanie z cache’owanym wariantem się nie uda,
 *   cache jest kasowany i wariant pobierany raz jeszcze.
 *   WYMAGANIE W SHOPIFY: produkt e-booka musi być opublikowany w kanale „Sklep internetowy” (inaczej /products/….js
 *   i add.js zwracają 404/422). Żeby nie był widoczny w wyszukiwarce i kolekcjach: ukryj go w SEO / wyklucz z kolekcji.
 *
 * ODPORNOŚĆ (nic tu nie może zablokować zakupu)
 *   - Wszystko w try/catch, brak alertów. Produkt e-booka nie istnieje / 404 / niedostępny / błąd sieci / timeout 8 s
 *     => skrypt cicho nic nie robi, koszyk działa jak bez niego.
 *   - Kontrolki ilości / „usuń” są blokowane (klasa cart__items--disabled) tylko na czas samej zmiany koszyka; pobieranie
 *     wariantu z /products/….js ich nie blokuje (wiszące żądanie nie zamraża drawera na 8 s).
 *   - Nieudane dodanie e-booka = przerwa 20 s przed kolejną próbą (żeby nie spamować 422).
 *   - Przycisk „Przejdź do kasy”: jeśli w tej chwili trwa rekonsyliacja, klik jest wstrzymany do jej końca (maks. 4 s),
 *     po czym idzie normalnie — kasa nigdy nie zostaje zablokowana.
 *   - W edytorze motywu (Shopify.designMode) skrypt się nie uruchamia.
 *
 * ELEMENTY POZA TYM PLIKIEM (razem tworzą funkcję)
 *   - layout/theme.liquid: ładuje ten plik (defer) i przekazuje handle w atrybutach data-ebook-handle / data-main-handle.
 *   - snippets/cart-drawer.liquid, sections/main-cart-items.liquid: pozycja e-booka na końcu listy, bez quantity selectora
 *     i przycisku „usuń”, z napisem GRATIS. Klasa wiersza: `cart-item--product-<handle e-booka>`.
 *   - sections/cart-icon-bubble.liquid, sections/header.liquid, snippets/cart-drawer.liquid (nagłówek „Koszyk (N)”):
 *     e-book nie wlicza się do licznika (tak jak produkty z tagiem `cart-hidden`).
 *   - snippets/levina-kosz-bundle.liquid: picker dodaje samego Drapakoszyka (bez property „Gratis”).
 *
 * JAK ZMIENIĆ HANDLE
 *   Zmień w 5 plikach (wszędzie stała na górze, szukaj `lvk_ebook_handle`):
 *     layout/theme.liquid (data-ebook-handle), snippets/cart-drawer.liquid, sections/main-cart-items.liquid,
 *     sections/cart-icon-bubble.liquid, sections/header.liquid.
 *   Handle Drapakoszyka (`levina-drapakoszyk`): layout/theme.liquid (data-main-handle) — reszta szablonów go nie potrzebuje.
 *   Od 26.10 data-main-handle może być listą po przecinku (`levina-drapakoszyk,levina-drapakoszyk-1plus1`): produkt-duplikat strony 1+1 też liczy się jako Drapakoszyk.
 *   Handle zmieniony w adminie Shopify (Produkty → e-book → Optymalizacja SEO → Uchwyt) przestaje pasować, dopóki
 *   nie zmienisz go tutaj — wtedy skrypt uzna, że e-booka nie ma i doda drugi.
 *
 * ZNANE OGRANICZENIA
 *   - Między zmianą koszyka a odświeżeniem UI mija ~0,3–0,6 s: przy usuwaniu ostatniego Drapakoszyka przyciskiem „usuń”
 *     w drawerze koszyk jest czyszczony jednym żądaniem (skrypt dopisuje handle e-booka do `upsellHandles` drawera),
 *     ale na stronie /cart przez chwilę widać samą pozycję e-booka.
 *   - Kolejność pozycji w koszyku Shopify to „najnowsza pierwsza”, więc e-book ląduje w danych na górze; szablony
 *     Liquid wyświetlają go na dole listy (numery linii `data-index` zostają prawdziwe).
 *   - Skrypt zna tylko drawer, stronę /cart i bąbelek. Powiadomienie koszyka (cart_type = notification) odświeża tylko
 *     bąbelek. Koszyki aplikacji z własnym renderem (Shop Pay itp.) zobaczą e-book po własnym odświeżeniu.
 *   - Klient z wyłączonym JS dostaje koszyk bez e-booka (e-book dodaje wyłącznie JS).
 *   - Linki „permalink” /cart/<id_wariantu>:<ilość> (np. z reklam) omijają theme i JS — e-booka w takim koszyku nie będzie.
 *     Jeśli ich używasz, dopisz do linku e-book: /cart/<id_Drapakoszyka>:1,<id_e-booka>:1.
 *   - Kasa (checkout) nie należy do theme: jeśli klientka usunie Drapakoszyka dopiero w kasie, e-book zostaje w zamówieniu
 *     jako pozycja 0,00 zł, a po powrocie do sklepu skrypt sam go usunie. Mail z PDF i tak wyzwala także pozycja e-booka
 *     (12_SHOPIFY_SETUP.md, sekcja 4).
 *   - Kolejne pozycje e-booka o innych właściwościach niż domyślne skrypt traktuje jak nadmiarowe i usuwa (zostaje jedna).
 *   - Produkt e-booka musi mieć wyłączone śledzenie zapasów (albo dużą ilość) — „niedostępny” = brak dodania (cicho).
 */
(function () {
  'use strict';

  if (window.__levinaEbookSync) return;
  window.__levinaEbookSync = true;

  try {
    if (window.Shopify && window.Shopify.designMode) return;
  } catch (e) { /* ignoruj */ }

  if (typeof window.fetch !== 'function' || typeof Promise === 'undefined') return;

  /* ---------- KONFIGURACJA ---------- */
  var script = document.currentScript || document.querySelector('script[src*="levina-kosz-ebook-sync"]');
  var ds = (script && script.dataset) || {};
  var CFG = window.LEVINA_EBOOK || {};

  var EBOOK_HANDLE = String(ds.ebookHandle || CFG.ebookHandle || 'ebook-sekretny-jezyk-kota');
  /* 26.10: data-main-handle może być LISTĄ po przecinku (np. „levina-drapakoszyk,levina-drapakoszyk-1plus1” — strona 1+1 jest osobnym produktem).
     Pojedyncza wartość działa jak dotąd. */
  var MAIN_HANDLES = String(ds.mainHandle || CFG.mainHandle || 'levina-drapakoszyk').split(',').map(function (h) { return h.replace(/^\s+|\s+$/g, ''); }).filter(Boolean);
  if (!MAIN_HANDLES.length) MAIN_HANDLES = ['levina-drapakoszyk'];
  var MAIN_HANDLE = MAIN_HANDLES[0];
  var DEBUG = String(ds.debug || CFG.debug || '') === 'true';

  var DEBOUNCE_MS = 150;        /* złożenie serii zmian koszyka w jedną rekonsyliację */
  var TIMEOUT_MS = 8000;        /* limit jednego żądania sieciowego */
  var UI_CHECK_MS = 700;        /* kontrola zgodności DOM po zmianie */
  var FAIL_COOLDOWN_MS = 20000; /* przerwa po nieudanym dodaniu e-booka */
  var CHECKOUT_WAIT_MS = 4000;  /* maks. wstrzymanie kliknięcia „do kasy” */
  var VARIANT_TTL_MS = 6 * 60 * 60 * 1000;
  var MISSING_TTL_MS = 5 * 60 * 1000;
  var STORAGE_KEY = 'lvkEbookVariant';

  var ORIG_FETCH = window.fetch;

  function log() {
    if (!DEBUG || !window.console || !console.debug) return;
    try { console.debug.apply(console, ['[levina-ebook]'].concat([].slice.call(arguments))); } catch (e) { /* ignoruj */ }
  }

  /* ---------- ŚCIEŻKI ---------- */
  function root() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (typeof r === 'string' && r) ? r : '/';
  }

  var CART_MUTATION = /\/cart\/(?:add|change|update|clear)(?:\.js|\.json)?(?:[?#]|$)/i;

  function isCartMutation(u) {
    try {
      var s = String(u || '').replace(/^[a-z][a-z0-9+.-]*:\/\/[^/]+/i, '');
      return CART_MUTATION.test(s);
    } catch (e) { return false; }
  }

  /* ---------- ŻĄDANIA (oryginalny fetch, z pominięciem hooka) ---------- */
  function request(method, path, body) {
    var opts = { method: method, credentials: 'same-origin', headers: { 'Accept': 'application/json' } };
    if (method === 'GET') opts.cache = 'no-store';
    if (body) {
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    var ctrl = null;
    var tm = null;
    try {
      if (window.AbortController) {
        ctrl = new AbortController();
        opts.signal = ctrl.signal;
        tm = setTimeout(function () { try { ctrl.abort(); } catch (e) { /* ignoruj */ } }, TIMEOUT_MS);
      }
    } catch (e) { ctrl = null; }

    return ORIG_FETCH(root() + path, opts).then(function (res) {
      return res.text().then(function (txt) {
        if (tm) clearTimeout(tm);
        var data = null;
        try { data = txt ? JSON.parse(txt) : null; } catch (e) { data = null; }
        return { ok: !!res.ok, status: res.status, data: data };
      });
    }, function (err) {
      if (tm) clearTimeout(tm);
      throw err;
    });
  }

  function getCart() {
    return request('GET', 'cart.js').then(function (r) {
      return (r.ok && r.data && Array.isArray(r.data.items)) ? r.data : null;
    }).catch(function () { return null; });
  }

  function post(path, body, sectionIds) {
    var b = body || {};
    if (sectionIds && sectionIds.length) {
      b.sections = sectionIds;
      b.sections_url = window.location.pathname;
    }
    return request('POST', path, b).catch(function (e) {
      log('błąd żądania', path, e);
      return { ok: false, status: 0, data: null };
    });
  }

  /* ---------- WARIANT E-BOOKA (AJAX Product API + sessionStorage) ---------- */
  function readVariantCache() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (!o || o.handle !== EBOOK_HANDLE) return null;
      var ttl = o.id ? VARIANT_TTL_MS : MISSING_TTL_MS;
      if (!o.t || Date.now() - o.t > ttl) return null;
      return o;
    } catch (e) { return null; }
  }

  function writeVariantCache(id) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ handle: EBOOK_HANDLE, id: id || 0, t: Date.now() }));
    } catch (e) { /* prywatne okno itp. */ }
  }

  function clearVariantCache() {
    try { window.sessionStorage.removeItem(STORAGE_KEY); } catch (e) { /* ignoruj */ }
  }

  /* zwraca id wariantu albo 0 (brak produktu / niedostępny / błąd) */
  function getEbookVariantId(fresh) {
    if (!fresh) {
      var cached = readVariantCache();
      if (cached) return Promise.resolve(cached.id || 0);
    }
    return request('GET', 'products/' + encodeURIComponent(EBOOK_HANDLE) + '.js').then(function (r) {
      var id = 0;
      if (r.ok && r.data && Array.isArray(r.data.variants)) {
        for (var i = 0; i < r.data.variants.length; i++) {
          if (r.data.variants[i] && r.data.variants[i].available) { id = Number(r.data.variants[i].id) || 0; break; }
        }
      }
      writeVariantCache(id);
      return id;
    }).catch(function () { return 0; }); /* błąd sieci: bez zapisu do cache */
  }

  /* ---------- STAN KOSZYKA ---------- */
  function handleOf(item) {
    if (!item) return '';
    if (item.handle) return String(item.handle);
    var m = /\/products\/([^/?#]+)/.exec(String(item.url || ''));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function summarize(cart) {
    var out = { main: 0, lines: [] };
    (cart.items || []).forEach(function (it) {
      var h = handleOf(it);
      if (h === EBOOK_HANDLE) out.lines.push(it);
      else if (MAIN_HANDLES.indexOf(h) > -1) out.main += Number(it.quantity) || 0;
    });
    return out;
  }

  /* ---------- SEKCJE / UI ---------- */
  function sectionIds() {
    var ids = [];
    function add(id) { if (id && ids.indexOf(id) < 0) ids.push(id); }
    try {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        drawer.getSectionsToRender().forEach(function (s) { add(s && s.id); });
      }
    } catch (e) { /* ignoruj */ }
    var items = document.getElementById('main-cart-items');
    if (items) add(items.getAttribute('data-id'));
    var footer = document.getElementById('main-cart-footer');
    if (footer) add(footer.getAttribute('data-id'));
    if (document.getElementById('cart-icon-bubble')) add('cart-icon-bubble');
    return ids;
  }

  function parseSection(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.querySelector(selector);
  }

  function swapContents(el, html) {
    if (!el || !html) return;
    var src = parseSection(html, '.js-contents');
    var dst = el.querySelector('.js-contents') || el;
    if (src && dst) dst.innerHTML = src.innerHTML;
  }

  function swapBubble(html) {
    var el = document.getElementById('cart-icon-bubble');
    if (!el || !html) return;
    var src = parseSection(html, '.shopify-section');
    if (src) el.innerHTML = src.innerHTML;
  }

  function setBusy(on) {
    ['CartDrawer-CartItems', 'main-cart-items'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.classList.toggle('cart__items--disabled', !!on);
    });
  }

  /* data = odpowiedź add.js / change.js / update.js z polem `sections` */
  function applyUI(data) {
    var sections = data && data.sections;
    if (!sections) return false;
    var empty = typeof data.item_count === 'number' ? data.item_count === 0 : false;
    var applied = false;

    try {
      var drawer = document.querySelector('cart-drawer');
      var drawerHtml = sections['cart-drawer'];
      if (drawer && drawerHtml && typeof drawer.renderContents === 'function') {
        drawer.classList.toggle('is-empty', empty);
        drawer.renderContents(data, true); /* true = bez ponownego otwierania; renderContents odświeża też bąbelek */
        applied = true;
      } else if (sections['cart-icon-bubble']) {
        swapBubble(sections['cart-icon-bubble']);
        applied = true;
      }
    } catch (e) { log('drawer', e); }

    try {
      var itemsEl = document.getElementById('main-cart-items');
      var footerEl = document.getElementById('main-cart-footer');
      var cartItemsEl = document.querySelector('cart-items');
      if (itemsEl && sections[itemsEl.getAttribute('data-id')]) {
        swapContents(itemsEl, sections[itemsEl.getAttribute('data-id')]);
        if (cartItemsEl) cartItemsEl.classList.toggle('is-empty', empty);
        applied = true;
      }
      if (footerEl && sections[footerEl.getAttribute('data-id')]) {
        swapContents(footerEl, sections[footerEl.getAttribute('data-id')]);
        footerEl.classList.toggle('is-empty', empty);
        applied = true;
      }
    } catch (e) { log('strona koszyka', e); }

    return applied;
  }

  /* pełne odświeżenie UI z serwera (bez zmiany koszyka): to samo, co robi natywne updateCart() motywu */
  function refreshUI() {
    var ids = sectionIds();
    if (!ids.length) return Promise.resolve(false);
    return post('cart/update.js', { updates: {} }, ids).then(function (r) {
      return (r.ok && r.data) ? applyUI(r.data) : false;
    });
  }

  /* czy DOM (drawer / strona /cart) zgadza się z oczekiwaniem co do obecności e-booka */
  function uiMatches(wantEbook) {
    var sel = '.cart-item--product-' + EBOOK_HANDLE;
    var drawer = document.querySelector('cart-drawer');
    var page = document.getElementById('main-cart-items');
    var ok = true;
    if (drawer && drawer.querySelector('#CartDrawer-CartItems') && !!drawer.querySelector(sel) !== wantEbook) ok = false;
    if (page && !!page.querySelector(sel) !== wantEbook) ok = false;
    return ok;
  }

  /* natywne „usuń” w drawerze: gdy zostaje jedna „prawdziwa” pozycja, motyw czyści cały koszyk jednym żądaniem.
     Dopisujemy e-book do `upsellHandles`, żeby jego pozycja nie liczyła się do tej „prawdziwej” liczby. */
  function patchDrawerClear() {
    try {
      var d = document.querySelector('cart-drawer');
      if (!d || !Array.isArray(d.upsellHandles)) return;
      if (d.upsellHandles.indexOf(EBOOK_HANDLE) < 0) {
        d.upsellHandles.push(EBOOK_HANDLE);
        if (typeof d.checkForClear === 'function') d.checkForClear();
      }
    } catch (e) { /* ignoruj */ }
  }

  /* ---------- REKONSYLIACJA ---------- */
  var blockedUntil = 0;

  function addEbook(ids) {
    if (Date.now() < blockedUntil) { log('dodawanie wstrzymane (cooldown)'); return Promise.resolve(null); }

    function tryAdd(variantId) {
      return post('cart/add.js', { items: [{ id: variantId, quantity: 1 }] }, ids);
    }
    function fail() { blockedUntil = Date.now() + FAIL_COOLDOWN_MS; return null; }

    /* Kontrolki drawera / strony /cart blokujemy (setBusy) dopiero tuż przed zmianą koszyka, a NIE na czas pobierania
       wariantu z /products/….js: gdy Shopify nie odpowiada (do 8 s timeoutu), klientka nadal klika ilość / „usuń”. */
    return getEbookVariantId(false).then(function (id) {
      if (!id) { log('brak wariantu e-booka — nic nie dodaję'); return null; }
      setBusy(true);
      return tryAdd(id).then(function (r) {
        if (r.ok) return r;
        /* wariant mógł się zmienić: kasujemy cache i próbujemy raz jeszcze ze świeżym */
        clearVariantCache();
        setBusy(false);
        return getEbookVariantId(true).then(function (id2) {
          if (!id2 || id2 === id) return fail();
          setBusy(true);
          return tryAdd(id2).then(function (r2) { return r2.ok ? r2 : fail(); });
        });
      });
    });
  }

  function changeLine(line, qty, ids) {
    return post('cart/change.js', { id: line.key || String(line.variant_id || line.id), quantity: qty }, ids).then(function (r) {
      return r.ok ? r : null;
    });
  }

  function reconcile() {
    return getCart().then(function (cart) {
      if (!cart) return null;
      var s = summarize(cart);
      var want = s.main > 0 ? 1 : 0;
      var lines = s.lines;

      if (want === 0 && lines.length === 0) return null;
      if (want === 1 && lines.length === 1 && Number(lines[0].quantity) === 1) return { want: 1 }; /* stan dobry; kontrola UI (uiMatches) odświeży drawer, jeśli brakuje wiersza e-booka (07.10, po dodaniu popupu upsell) */

      /* nie ma czego dodać (cooldown po błędzie / produkt nie istnieje wg cache) — bez blokowania UI */
      if (want === 1 && lines.length === 0) {
        var known = readVariantCache();
        if (Date.now() < blockedUntil || (known && !known.id)) { log('e-book niedostępny — pomijam'); return null; }
      }

      log('rekonsyliacja: Drapakoszyk =', s.main, ', pozycje e-booka =', lines.length, '-> ma być', want);
      patchDrawerClear();

      var ids = sectionIds();
      var last = null;
      var recheck = false;
      var chain = Promise.resolve();
      /* usunięcie / korekta ilości to od razu zmiana koszyka → blokujemy kontrolki; dodanie e-booka blokuje dopiero addEbook() */
      if (want === 0 || lines.length > 0) setBusy(true);

      function step(fn) {
        chain = chain.then(function () {
          return fn().then(function (r) { if (r && r.data) last = r; });
        });
      }

      if (want === 0) {
        lines.forEach(function (ln) { step(function () { return changeLine(ln, 0, ids); }); });
      } else if (lines.length === 0) {
        step(function () {
          return addEbook(ids).then(function (r) {
            /* wyścig dwóch kart: obie zobaczyły koszyk bez e-booka i obie dodały → Shopify scala w jedną pozycję ×2.
               Odpowiedź add.js zwraca sumaryczną ilość pozycji, więc widzimy to od razu i prostujemy kolejną rekonsyliacją. */
            try {
              var added = r && r.data && r.data.items && r.data.items[0];
              if (added && Number(added.quantity) > 1) recheck = true;
            } catch (e) { /* ignoruj */ }
            return r;
          });
        });
      } else {
        if (Number(lines[0].quantity) !== 1) step(function () { return changeLine(lines[0], 1, ids); });
        lines.slice(1).forEach(function (ln) { step(function () { return changeLine(ln, 0, ids); }); });
      }

      return chain.then(function () {
        if (!last) return null;
        var data = last.data;
        var applied = data.sections ? applyUI(data) : false;
        return applied ? { want: want } : refreshUI().then(function () { return { want: want }; });
      }).then(function (res) {
        setBusy(false);
        if (recheck) schedule('duplikat po dodaniu');
        return res;
      }, function (err) {
        setBusy(false);
        throw err;
      });
    });
  }

  /* ---------- KOLEJKA (debounce + serializacja) ---------- */
  var timer = null;
  var running = false;
  var again = false;
  var waiters = [];

  function isBusy() { return !!timer || running; }

  function flushWaiters() {
    if (isBusy()) return;
    var w = waiters;
    waiters = [];
    w.forEach(function (fn) { try { fn(); } catch (e) { /* ignoruj */ } });
  }

  function whenIdle(maxMs) {
    return new Promise(function (resolve) {
      if (!isBusy()) { resolve(); return; }
      var done = false;
      var tm = setTimeout(function () { if (!done) { done = true; resolve(); } }, maxMs);
      waiters.push(function () { if (!done) { done = true; clearTimeout(tm); resolve(); } });
    });
  }

  function start() {
    if (running) { again = true; return; }
    running = true;
    var p;
    try { p = reconcile(); } catch (e) { p = Promise.resolve(null); }
    Promise.resolve(p).then(function (res) {
      if (res && typeof res.want === 'number') {
        setTimeout(function () {
          if (isBusy()) return; /* nowsza rekonsyliacja i tak odświeży UI */
          try {
            if (!uiMatches(res.want === 1)) { log('DOM niezgodny ze stanem — odświeżam UI'); refreshUI().catch(function () {}); }
          } catch (e) { /* ignoruj */ }
        }, UI_CHECK_MS);
      }
    }).catch(function (err) {
      log('błąd rekonsyliacji', err);
      setBusy(false);
    }).then(function () {
      running = false;
      if (again) { again = false; schedule('ponowienie'); } else flushWaiters();
    });
  }

  function schedule(reason) {
    log('wyzwalacz:', reason);
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; start(); }, DEBOUNCE_MS);
  }

  /* ---------- WYZWALACZE ---------- */
  /* 1) fetch */
  try {
    window.fetch = function (input) {
      var p = ORIG_FETCH.apply(window, arguments);
      try {
        var u = (typeof input === 'string') ? input : (input && input.url) || String(input);
        if (isCartMutation(u)) {
          var done = function () { schedule('fetch'); };
          p.then(done, done);
        }
      } catch (e) { /* ignoruj */ }
      return p;
    };
  } catch (e) { log('fetch hook', e); }

  /* 2) XMLHttpRequest (prototyp natywnego XHR; motyw podmienia konstruktor, ale zwraca natywną instancję) */
  try {
    var probe = new window.XMLHttpRequest();
    var xproto = Object.getPrototypeOf(probe);
    var xOpen = xproto.open;
    var xSend = xproto.send;
    if (typeof xOpen === 'function' && typeof xSend === 'function') {
      xproto.open = function (method, url) {
        try { this.__lvkCartUrl = isCartMutation(url); } catch (e) { /* ignoruj */ }
        return xOpen.apply(this, arguments);
      };
      xproto.send = function () {
        try {
          if (this.__lvkCartUrl) this.addEventListener('loadend', function () { schedule('xhr'); });
        } catch (e) { /* ignoruj */ }
        return xSend.apply(this, arguments);
      };
    }
  } catch (e) { log('xhr hook', e); }

  /* 3) zdarzenie koszyka Shrine (subscribe/PUB_SUB_EVENTS są globalami motywu, ładowanymi tym samym defer) */
  var subscribed = false;
  function subscribeCartEvents() {
    if (subscribed) return;
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { schedule('cartUpdate'); });
        subscribed = true;
      }
    } catch (e) { /* ignoruj */ }
  }

  /* 4) stan wyjściowy + bfcache */
  function init() {
    subscribeCartEvents();
    patchDrawerClear();
    schedule('start strony');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) schedule('pageshow');
  });

  /* 5) przycisk kasy nie omija rekonsyliacji */
  var bypassCheckout = false;
  document.addEventListener('click', function (e) {
    try {
      if (bypassCheckout || !isBusy()) return;
      var t = e.target;
      var btn = t && t.closest ? t.closest('[name="checkout"]') : null;
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var id = btn.id;
      whenIdle(CHECKOUT_WAIT_MS).then(function () {
        var target = btn.isConnected ? btn : ((id && document.getElementById(id)) || document.querySelector('[name="checkout"]'));
        if (!target) return;
        bypassCheckout = true;
        try { target.click(); } finally { bypassCheckout = false; }
      });
    } catch (err) { /* nigdy nie blokujemy kasy */ }
  }, true);

  /* diagnostyka z konsoli: LevinaEbookSync.sync() */
  window.LevinaEbookSync = {
    ebookHandle: EBOOK_HANDLE,
    mainHandle: MAIN_HANDLE,
    mainHandles: MAIN_HANDLES,
    sync: function () { schedule('ręcznie'); },
    isBusy: isBusy
  };
})();
